import { Passage } from "../utils/inputRow";
import { REST_API } from "../env/config";

export class UnauthorizedError extends Error {
  constructor() {
    super("Unauthorized. Please log in again.");
  }
}

export class PassageNotFoundError extends Error {
  book: string;
  chapter: string;
  verses: string;
  translation: string;

  constructor({
    book,
    chapter,
    verses,
    translation,
  }: {
    book: string;
    chapter: string;
    verses: string;
    translation: string;
  }) {
    const message = `Not found. Passage: ${book} ${chapter},${verses} (${translation})`;
    super(message);
    this.name = "PassageNotFoundError";
    this.book = book;
    this.chapter = chapter;
    this.verses = verses;
    this.translation = translation;
  }
}

export async function retreivePassageText(e: Passage): Promise<string> {
  e = JSON.parse(JSON.stringify(e));
  e.translation = e.translation.split("(")[1].replace(")", "");

  const url = REST_API + "/passage";

  const token = localStorage.getItem("token");

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(e),
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new UnauthorizedError();
    } else if (response.status === 404) {
      throw new PassageNotFoundError(e);
    }
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  return response.text();
}
